// extracted by mini-css-extract-plugin
export default {"layout":"EmbeddedLayout_layout__doWK8"};